/**
 * 全局扩展工具函数
 * @date: 2019/1/7
 * @author: xkh
 */

/**
 * 获取值在数组中的区间索引
 * @param value
 * @returns {number}
 */
Array.prototype.arrayIndex = function (value) {
    let index = 0;
    this.filter((el, i) => {
        if (value > this[i] && value <= this[i + 1]) {
            index = i;
        }
    });
    return index;
};

/**
 * 获取数组中最大、最小值
 * @returns {number}
 */
Array.prototype.max = function () { return Math.max.apply({},this); };
Array.prototype.min = function () { return Math.min.apply({},this); };

/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * 例子：
 * (new Date()).format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * (new Date()).format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 * @param fmt
 * @returns {*}
 */
Date.prototype.format = function (fmt) {
    const o = {
        'M+': this.getMonth() + 1, //月份
        'd+': this.getDate(), //日
        'h+': this.getHours(), //小时
        'm+': this.getMinutes(), //分
        's+': this.getSeconds(), //秒
        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
        'S': this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
};
